import { createContext } from 'react';

const InfoContext = createContext(null);

export default InfoContext;
